import type React from 'react';

import { usePatchStream } from '@vlabs/api/artemy/client';
import type { StreamId } from '@vlabs/api/artemy/model';
import { toast } from 'react-toastify';

import { useStartStopStreamTranslation } from '@vlabs/monokit/features/start-stop-stream/i18n';

import { StreamStatus } from './StreamStatus';

interface StreamStatusWithActionsProps {
  streamId: StreamId;
  status: number;
}

/** Пилюля статуса с кнопками запуска/остановки — патч вызывается внутри. */
function StreamStatusWithActions({
  streamId,
  status,
}: StreamStatusWithActionsProps): React.JSX.Element | null {
  const { t } = useStartStopStreamTranslation();
  const patchStream = usePatchStream({
    mutation: {
      onSuccess: () => toast.success(t('on_success')),
      onError: () => toast.error(t('on_error')),
    },
  });

  const patch = (action: 'stop' | 'resume') => {
    patchStream.mutate({ streamId, data: { action } });
  };

  return (
    <StreamStatus
      onStart={() => patch('resume')}
      onStop={() => patch('stop')}
      status={status}
      type="text+button"
    />
  );
}

export { StreamStatusWithActions };
